<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Parámetros</h3>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__content">
            <div class="row">
              <!-- <div class="col-xs-12 col-md-4">
                <div class="form-field select">
                  <div class="select-field">
                    <select
                      name="bodega_reservada"
                      id="bodega_reservada"
                      v-model="form.bodega_reservada_id"
                    >
                      <option
                        :value="bodega.id"
                        v-for="bodega in bodegas"
                        :key="bodega.id"
                      >
                        {{ bodega.descripcion }}
                      </option>
                    </select>
                    <label for="bodega_reservada">Bodega reservada</label>
                  </div>
                </div>
              </div> -->
              <!-- <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    id="letra_contrato"
                    v-model="form.letra_contrato"
                    placeholder="Indique el prefijo..."
                  >
                    <span>Prefijo de número de contrato</span>
                    <span
                      v-if="errores.letra_contrato"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.letra_contrato[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div> -->
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field vMoney :format="porcentaje" id="porc_interes" v-model="form.porc_interes"
                    placeholder="Indique el monto...">
                    <span>% Interés</span>
                    <span v-if="errores.porc_interes" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.porc_interes[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="monto_maximo_venta" v-model="form.monto_maximo_venta" vMoney :format="money"
                    placeholder="Indique el monto...">
                    <span>Monto máximo de venta</span>
                    <span v-if="errores.monto_maximo_venta" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.monto_maximo_venta[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="cantidad_ventas" v-model="form.cantidad_ventas" vMoney :format="int"
                    placeholder="Indique el monto...">
                    <span>Cantidad de ventas límite</span>
                    <span v-if="errores.cantidad_ventas" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.cantidad_ventas[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <!-- <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    id="porc_rec_inicial"
                    v-model="form.porc_rec_inicial"
                    vMoney
                    :format="int"
                    placeholder="Indique el porcentaje..."
                  >
                    <span>% Recaudador inicial</span>
                    <span
                      v-if="errores.porc_rec_inicial"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.porc_rec_inicial[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div> -->
              <!-- <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    id="porc_rec_final"
                    v-model="form.porc_rec_final"
                    vMoney
                    :format="int"
                    placeholder="Indique el porcentaje..."
                  >
                    <span>% Recaudador final</span>
                    <span
                      v-if="errores.porc_rec_final"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.porc_rec_final[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div> -->
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <label for="habilitar_rubro_otros">
                    <input v-model="form.habilitar_rubro_otros" type="checkbox" name="habilitar_rubro_otros"
                      id="habilitar_rubro_otros"><span>Habilitar rubro "Otros" en recaudaciones</span>
                  </label>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <label for="producto_manual_ventas">
                    <input v-model="form.producto_manual_ventas" type="checkbox" name="producto_manual_ventas"
                      id="producto_manual_ventas"><span>Productos manuales en ventas</span>
                  </label>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <label for="producto_manual_recaudacion">
                    <input v-model="form.producto_manual_recaudacion" type="checkbox" name="producto_manual_recaudacion"
                      id="producto_manual_recaudacion"><span>Productos manuales en recaudación</span>
                  </label>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="dias_cartera" v-model="form.dias_cartera"
                    placeholder="Indique los días separados por coma...">
                    <span>Días de proyección de cartera</span>
                    <span v-if="errores.dias_cartera" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.dias_cartera[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="porc_tarjetas" v-model="form.porc_tarjetas"
                    placeholder="Indique los porcentajes separados por coma...">
                    <span>% Recaudación en Tarjetas</span>
                    <span v-if="errores.porc_tarjetas" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.porc_tarjetas[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="porc_tarjeta_recaudador" v-model="form.porc_tarjeta_recaudador"
                    placeholder="Indique los porcentajes separados por coma...">
                    <span>% Recaudación por Recaudador</span>
                    <span v-if="errores.porc_tarjeta_recaudador" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.porc_tarjeta_recaudador[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="porc_supervision" v-model="form.porc_supervision" vMoney :format="porcentaje"
                    placeholder="Indique los porcentajes separados por coma...">
                    <span>% Supervisión en Recaudación</span>
                    <span v-if="errores.porc_supervision" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.porc_supervision[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="porc_cobradas" v-model="form.porc_cobradas" vMoney :format="int">
                    <span>Min. Tarj. Cobradas en Rol de Recaudación</span>
                    <span v-if="errores.porc_cobradas" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.porc_cobradas[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="porc_incobrable" v-model="form.porc_incobrable" vMoney :format="porcentaje"
                    placeholder="Indique los porcentajes separados por coma...">
                    <span>% Incobrables</span>
                    <span v-if="errores.porc_incobrable" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.porc_incobrable[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="valor_minimo_cobro" vMoney :format="money" v-model="form.valor_minimo_cobro"
                    placeholder="Indique los porcentajes separados por coma...">
                    <span>Valor mínimo de cobro</span>
                    <span v-if="errores.valor_minimo_cobro" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.valor_minimo_cobro[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="valor_referido" vMoney :format="money" v-model="form.valor_referido"
                    placeholder="Escriba el valor por tarjeta referida...">
                    <span>Valor referido</span>
                    <span v-if="errores.valor_referido" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.valor_referido[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select label="descripcion" @input="inputTipoMovimiento" placeholder="Seleccione..."
                      id="mov_liq_venta_id" :options="tiposMovimiento" v-model="selectedTipoMovimiento"></v-select>
                    <label for="mov_liq_venta_id">Tipo de Movimiento Pago Liq. Venta</label>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select label="descripcion" @input="inputMovTarjRef" placeholder="Seleccione..."
                      id="mov_tarj_ref_id" :options="tiposMovimiento" v-model="selectedMovTarjRef"></v-select>
                    <label for="mov_tarj_ref_id">Tipo de Movimiento Tarj. Ref.</label>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select label="descripcion" @input="inputMovRec" placeholder="Seleccione..." id="mov_rol_rec_id"
                      :options="tiposMovimientoRecaudacion" v-model="selectedMovRec"></v-select>
                    <label for="mov_rol_rec_id">Tipo de Movimiento Rol de Recaudador</label>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field type="password" id="clave_excel" v-model="form.clave_excel" placeholder="*******">
                    Clave de archivo de Excel
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field vMoney :format="porcentaje" id="porc_multa" v-model="form.porc_multa"
                    placeholder="Indique el porcentaje multa...">
                    <span>% multa</span>
                    <span v-if="errores.porc_multa" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.porc_multa[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="cuotas" v-model="form.cuotas" vMoney :format="int"
                    placeholder="Indique las cuotas...">
                    <span>Cuotas</span>
                    <span v-if="errores.cuotas" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.cuotas[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field vMoney :format="porcentaje" id="porc_microseguro" v-model="form.porc_microseguro"
                    placeholder="Indique el porcentaje multa...">
                    <span>Microseguro</span>
                    <span v-if="errores.porc_microseguro" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.porc_microseguro[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field 
                    vMoney
                    :format="numero"
                    id="contacto_telefono" 
                    v-model="form.contacto_telefono">
                    <span>Telefono</span>
                    <span v-if="errores.contacto_telefono" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.contacto_telefono[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <h3>Comisiones</h3>
                <div style="max-height: 300px" class="table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th>Venta inicial</th>
                        <th>Venta final</th>
                        <th>Valor de comisión</th>
                        <th>Valor inicial</th>
                        <th>
                          <div>
                            <button @click="agregarComision" class="btn-success"><i class="fa fa-plus"></i></button>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(comision, index) in form.comisiones" :key="comision.id">
                        <td>
                          <div class="form-field">
                            <input-field vMoney :format="money" placeholder="Valor de venta inicial..."
                              id="valor_venta_inicial" v-model="comision.valor_venta_inicial"></input-field>
                          </div>
                        </td>
                        <td>
                          <div class="form-field">
                            <input-field vMoney :format="money" placeholder="Valor de venta final..."
                              id="valor_venta_final" v-model="comision.valor_venta_final"></input-field>
                          </div>
                        </td>
                        <td>
                          <div class="form-field">
                            <input-field vMoney :format="money" placeholder="Valor de comisión..." id="valor_comision"
                              v-model="comision.valor_comision"></input-field>
                          </div>
                        </td>
                        <td>
                          <div class="form-field">
                            <input-field vMoney :format="money" placeholder="Valor inicial..." id="valor_inicial"
                              v-model="comision.valor_inicial"></input-field>
                          </div>
                        </td>
                        <td>
                          <button type="button" @click="eliminarComision(index)" class="btn-danger btn--text"><i
                              class="fa fa-trash"></i></button>
                        </td>
                      </tr>
                      <tr v-show="form.comisiones.length == 0">
                        <td colspan="4">
                          <strong>No se ha agregado comisiones.</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div style="max-height: 300px" class="table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th>Usuario</th>
                        <th>Versión</th>
                        <th>Fecha de última actualización</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="usuario in usuarios" :key="usuario.id">
                        <td>
                          {{ usuario.usuario.nombre }}
                        </td>
                        <td>
                          {{ usuario.version }}
                        </td>
                        <td>
                          {{ usuario.fecha_ultima_actualizacion }}
                        </td>
                      </tr>
                      <tr v-show="usuarios.length === 0">
                        <td colspan="3">
                          <strong>No se ha encontrado actualizaciones de versiones.</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button type="button" @click="guardar" class="btn-success">
              <i class="fa fa-save"></i><span>Guardar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    inputMovRec: function () {
      if (this.selectedMovRec != null)
        this.form.mov_rol_rec_id = this.selectedMovRec.codigo;
      else
        this.form.mov_rol_rec_id = '';
    },
    inputMovTarjRef: function () {
      if (this.selectedTipoMovimiento != null)
        this.form.mov_tarj_ref_id = this.selectedTipoMovimiento.codigo;
      else
        this.form.mov_tarj_ref_id = '';
    },
    inputTipoMovimiento: function () {
      if (this.selectedTipoMovimiento != null)
        this.form.mov_liq_venta_id = this.selectedTipoMovimiento.codigo;
      else
        this.form.mov_liq_venta_id = '';
    },
    eliminarComision: function (index) {
      this.form.comisiones.splice(index, 1);
    },
    agregarComision: function () {
      this.form.comisiones.push({
        id: moment(new Date()).format('YYYYMMDDHHmmss') + this.form.comisiones.length,
        valor_venta_inicial: '',
        valor_venta_final: '',
        valor_comision: '',
        valor_inicial: ''
      });
    },
    cargarDatos: function () {
      axios
        .get(url + "/parametros")
        .then(({ data }) => {
          this.bodegas = data.bodegas;
          if (data.parametros != null) {
            this.tiposMovimiento = data.tiposMovimiento;
            this.tiposMovimientoRecaudacion = data.tiposMovimientoRecaudacion;
            this.form.clave_excel = data.parametros.clave_excel;
            this.form.habilitar_rubro_otros = data.parametros.habilitar_rubro_otros == 'S';
            this.form.letra_contrato = data.parametros.letra_contrato;
            this.form.monto_maximo_venta = data.parametros.monto_maximo_venta;
            this.form.producto_manual_ventas = data.parametros.producto_manual_ventas === 'S';
            this.form.producto_manual_recaudacion = data.parametros.producto_manual_recaudacion === 'S';
            this.form.cantidad_ventas = data.parametros.cantidad_ventas;
            this.form.porc_rec_final = data.parametros.porc_rec_final;
            this.form.porc_rec_inicial = data.parametros.porc_rec_inicial;
            this.form.dias_cartera = data.parametros.dias_cartera;
            this.form.porc_tarjetas = data.parametros.porc_tarjetas;
            this.form.porc_tarjeta_recaudador = data.parametros.porc_tarjeta_recaudador;
            this.form.valor_minimo_cobro = data.parametros.valor_minimo_cobro;
            this.form.porc_supervision = data.parametros.porc_supervision;
            this.form.porc_cobradas = data.parametros.porc_cobradas;
            this.form.porc_incobrable = data.parametros.porc_incobrable;
            this.form.valor_referido = data.parametros.valor_referido;
            this.form.comisiones = data.comisiones;
            this.form.porc_interes = data.parametros.porc_interes;
            this.form.porc_multa = data.parametros.porc_multa;
            this.form.cuotas = data.parametros.cuotas;
            this.form.porc_microseguro = data.parametros.porc_microseguro;
            this.form.contacto_telefono = data.parametros.contacto_telefono;
            for (let i = 0; i < this.tiposMovimiento.length; i++) {
              if (data.parametros.mov_liq_venta_id == this.tiposMovimiento[i].codigo) {
                this.selectedTipoMovimiento = this.tiposMovimiento[i];
                this.form.mov_liq_venta_id = data.parametros.mov_liq_venta_id;
                break;
              }
            }
            for (let i = 0; i < this.tiposMovimiento.length; i++) {
              if (data.parametros.mov_tarj_ref_id == this.tiposMovimiento[i].codigo) {
                this.selectedMovTarjRef = this.tiposMovimiento[i];
                this.form.mov_tarj_ref_id = data.parametros.mov_tarj_ref_id;
                break;
              }
            }
            for (let i = 0; i < this.tiposMovimientoRecaudacion.length; i++) {
              if (data.parametros.mov_rol_rec_id == this.tiposMovimientoRecaudacion[i].codigo) {
                this.selectedMovRec = this.tiposMovimientoRecaudacion[i];
                this.form.mov_rol_rec_id = data.parametros.mov_rol_rec_id;
                break;
              }
            }
            this.usuarios = data.usuarios;
          }
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    guardar: function () {
      swal({
        title: "¿Desea actualizar los parámetros del sistema?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/parametros", this.form)
            .then(() => {
              swal(
                "Los parámetros fueron almacenados exitósamente.",
                "Aviso",
                "success"
              );
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status == 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Error", "error");
              }
            });
        }
      });
    },
  },
  data: function () {
    return {
      tiposMovimientoRecaudacion: [],
      selectedMovTarjRef: null,
      tiposMovimiento: [],
      porcentaje: porcentaje,
      money: money,
      numero: numero,
      selectedMovRec: null,
      form: {
        clave_excel: '',
        habilitar_rubro_otros: false,
        mov_tarj_ref_id: '',
        porc_cobradas: 0.67,
        letra_contrato: "A",
        monto_maximo_venta: 150,
        producto_manual_ventas: false,
        producto_manual_recaudacion: false,
        cantidad_ventas: 2,
        porc_rec_inicial: 0,
        porc_rec_final: 0,
        dias_cartera: '',
        comisiones: [],
        porc_tarjetas: '',
        porc_tarjeta_recaudador: '',
        porc_supervision: 10,
        valor_minimo_cobro: 10,
        valor_referido: 1.5,
        porc_incobrable: 50,
        mov_liq_venta_id: '',
        porc_multa: 0,
        cuotas: 0,
        porc_microseguro: 0,
        contacto_telefono: '',
      },
      bodegas: [],
      errores: {},
      int: int,
      usuarios: [],
      selectedTipoMovimiento: null
    };
  },
  mounted: function () {
    this.cargarDatos();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/general/Parametros.vue